import { ConfirmExitAlert } from './ConfirmExitAlert';

export const ExitEditorDialog = ({
  onExit,
  onClose,
  isOpen,
  isUpdate,
}: {
  onExit: () => void;
  onClose: () => void;
  isOpen: boolean;
  isUpdate: boolean;
}) => (
  <ConfirmExitAlert
    title="Discard changes"
    description={
      isUpdate
        ? 'Discard your changes and leave the editor?'
        : 'Discard your progress and leave the editor?'
    }
    yesLabel="Discard and exit"
    {...{ isOpen, onClose, onExit }}
  />
);
